module.exports = __webpack_public_path__ + "img/more-info-chem.ed5de8f1.svg";